<app-loader [isLoading]="isLoading"></app-loader>
@if(isUuid){
<router-outlet></router-outlet>
}@else {

<div class="header">
  <app-title [title]="title" [subtitle]="subtitle"></app-title>
  @if (myroles.can_write) {
  <div class="top">
    <!-- <div class="boton">
            <button class="b1" mat-button (click)="addUser()">Añadir usuario</button>
        </div> -->
  </div>
  }
</div>

<div class="content">
  <div class="filter">
    <div class="left-section">
      <div class="search-section">
        <mat-form-field appearance="outline">
          <mat-label>Buscar trabajador</mat-label>
          <mat-icon matTextPrefix style="position: relative; top: +0.33em">search</mat-icon>
          <input matInput type="search" [formControl]="filterControl" />
        </mat-form-field>
      </div>
    </div>
    <div class="paginator-container">
      <mat-paginator [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons aria-label="Select page of users"
        class="paginator-field">
      </mat-paginator>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
    class="mat-elevation-z8 table">
    <!-- Username Column -->
    <ng-container matColumnDef="username">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        NOMBRE DE USUARIO
      </th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{
          element.user?.username | qeqPipe
          }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="external_id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>ID EXTERNO</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{ element.external_id }}</span>
      </td>
    </ng-container>

    <!-- Email Column -->
    <!-- <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>EMAIL</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{ element.user?.email }}</span>
      </td>
    </ng-container> -->

    <!-- Actions Column -->
    <ng-container matColumnDef="acciones">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        @if (myroles.can_write) {
        <button mat-icon-button class="acciones" (click)="goToUser(element.external_id)">
          <mat-icon svgIcon="edit"></mat-icon></button>}
        <!-- @if (myroles.can_delete) {
                <button mat-icon-button class="acciones"
                    (click)="deleteSelected(element.id, element.user?.username)"><mat-icon
                        svgIcon="delete"></mat-icon></button>} -->
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
}